import { Component, ViewEncapsulation, Input, Injectable, ViewChild   } from '@angular/core';
import { AppGlobals } from '../../shared/app.global';
import { ScalingComponent } from '../../shell/scaling/scaling.component';
import { ElementRef } from '@angular/core';
import { interActivityServices } from '../../shared/services/interactivity.services';


declare var $: any;
@Injectable()

export class SliderControllerComponent{
  public silderObj = {};
  private sliderValueArr = [] 
  constructor(public scaleCompo: ScalingComponent, public services: interActivityServices) {}

  init(_element,_obj):void{
    this.silderObj = _obj;
    this.createSliderArr(this.silderObj);
    this.setEvents(_element)
  }

  createSliderArr(_obj):void {
    for (let i = 0; i <= _obj.steps; i++){
      let _val = (_obj.max_left / _obj.steps) * i;
      this.sliderValueArr.push(_val)
  } 
  }
  setEvents(_element){
     let self = this;
     this.createDrggableSlider(_element);
     this.setDefaultValue(_element);
    _element.unbind("keyup").bind("keyup", function (event) {
      if (!(event.keyCode == 37 || event.keyCode == 39)) return true;
      let _getOrginalLeft = parseInt(_element.css("left")) // get slider left
      let keyCount = self.sliderValueArr.indexOf(_getOrginalLeft); // get current keycount position

      let _val = event.keyCode == 39 ? ++keyCount : --keyCount;

      if (self.sliderValueArr[_val] || self.sliderValueArr[_val] === 0) {
        _element.css("left", self.sliderValueArr[_val])
        $('.sliderFill').css("width", self.sliderValueArr[_val]);
        self.getSliderVal(self.silderObj, self.sliderValueArr[_val]);
      }
    })
  }

  createDrggableSlider(_element){
     let self = this;
     let click_y;
     let setLeft;
     _element.draggable({
       axis: "x",
       containment: "parent",
       start: function (event, ui) {
         click_y = event.clientX;
       },
       drag: function (event, ui) {
         let original = ui.originalPosition;
         let zoom = self.scaleCompo.scaleFactor// shell zoom value
         let diff = event.clientX - click_y;
          setLeft = (diff + original.left) / zoom;

         function closest(num, arr):number {
           let curr = arr[0];
           for (let i = 0; i <= arr.length; i++)
             if (Math.abs(num - arr[i]) < Math.abs(num - curr)) {
               curr = arr[i]
             }
           return curr
         }

         setLeft = closest(setLeft, self.sliderValueArr)
         ui.position = {
           left: setLeft
         };
         self.getSliderVal(self.silderObj, setLeft);
         $('.sliderFill').css("width", setLeft);
       }
     })
     
 
   } 
  getSliderVal(_sliderObj,_sliderVal) {
    let _getIndex = this.sliderValueArr.indexOf(_sliderVal);
    let _val = _getIndex * _sliderObj.val;
    
    let evt = new CustomEvent('sliderValuechanged', { detail: {
      "orginalVal": _getIndex,
      "value": _val
    }});
    // this.services.sliderValue = _val;
    document.dispatchEvent(evt);
  }
  resetSlider(){
    // $('.sliderParent *').removeAttr('style');
    this.setDefaultValue($('#handle'))
  }
  setDefaultValue(_element){
    let _left = this.sliderValueArr[(<any>this.silderObj).initPos]
    _element.css("left", _left);
    $('.sliderFill').css("width", _left);
  }
 
}
